import clubSvg from '../../../../assets/images/suit/club.svg'
import diamondSvg from '../../../../assets/images/suit/diamond.svg'
import heartSvg from '../../../../assets/images/suit/heart.svg'
import spadeSvg from '../../../../assets/images/suit/spade.svg'
import { ESuitSymbol } from '../enums'

export const suitSvgByName: Record<ESuitSymbol, string> = {
  [ESuitSymbol.CLUB]: clubSvg,
  [ESuitSymbol.HEART]: heartSvg,
  [ESuitSymbol.DIAMOND]: diamondSvg,
  [ESuitSymbol.SPADE]: spadeSvg,
}
